<button
	cdxButton
	fillStyle="secondaryOutline"
	[chip]="true"
	endSlotSize="extra-small"
	[endSlotActive]="true"
	class="filter-trigger"
	(click)="openFilter()"
	[attr.data-testId]="'filter-group-button'"
	[checked]="(isFilterOpen$ | async) || selectedFiltersNum > 0"
	[slotCounterActive]="selectedFiltersNum > 0"
	[inline]="true"
	focusVisibleStyle="dark-dashed"
	#filterTrigger
>
	{{ filterTitle }}
	<span counter>
		{{ selectedFiltersNum }}
	</span>
	<cdx-svg-icon [name]="sorterIcon | async" size="extra-small" fill="currentColor" end></cdx-svg-icon>
</button>

<ng-template cdkPortal #filterModal="cdkPortal">
	<cdx-slotted-modal class="search-filter" size="medium" (close)="onCloseFilterModal()" [verticalPadding]="'medium'">
		<div modal-content class="filter">
			<h2 class="title">{{ filterTitle }}</h2>
			<ul class="filter-options-list">
				<li *ngFor="let option of nextFilterOptions; trackBy: trackByOptionNameFn" class="filter-option">
					<input
						type="checkbox"
						[attr.name]="option.filter.name"
						[attr.id]="option.filter.name"
						[(ngModel)]="option.isSelected"
					/>
					<label [for]="option.filter.name"
						>{{ option.filter.name | titlecase }} ({{ option.filter.productCount }})</label
					>
				</li>
			</ul>
			<search-filter-disclaimer
				*ngIf="canShowDisclaimer(nextFilterOptions[0].filter)"
				[newStyleForFilters]="true"
			></search-filter-disclaimer>
		</div>
		<button
			modal-footer-primary
			cdxButton
			fillStyle="primary"
			(click)="applyFilters()"
			[disabled]="isApplyFiltersDisabled"
		>
			Apply
		</button>
		<button
			modal-footer-secondary
			cdxButton
			fillStyle="outline"
			(click)="clearFilters()"
			[disabled]="!isAnyFilterOptionSelected"
		>
			Clear all
		</button>
	</cdx-slotted-modal>
</ng-template>

<ng-template cdkPortal cdkTrapFocus #filterDropdown="cdkPortal">
	<section class="filter-dropdown" role="listbox">
		<ul class="filter-options-list">
			<li *ngFor="let option of nextFilterOptions; trackBy: trackByOptionNameFn" class="filter-option">
				<input
					type="checkbox"
					[attr.name]="option.filter.name"
					[attr.id]="option.filter.name"
					[(ngModel)]="option.isSelected"
				/>
				<label [for]="option.filter.name"
					>{{ option.filter.name | titlecase }} ({{ option.filter.productCount }})</label
				>
			</li>
		</ul>
		<div *ngIf="canShowDisclaimer(nextFilterOptions[0].filter)" class="disclaimer-container">
			<search-filter-disclaimer [newStyleForFilters]="true"></search-filter-disclaimer>
		</div>
		<div class="cta-container">
			<button
				cdxButton
				fillStyle="outline"
				(click)="clearFilters()"
				[inline]="true"
				[disabled]="!isAnyFilterOptionSelected"
			>
				Clear all
			</button>
			<button
				cdxButton
				fillStyle="primary"
				(click)="applyFilters()"
				[inline]="true"
				[disabled]="isApplyFiltersDisabled"
			>
				Apply
			</button>
		</div>
	</section>
</ng-template>
